<template>
<div>

  <v-flex md4 row>
    <v-text-field data-authentication="pin"
    v-model="pinInput" 
    label="Pincode" 
    required
    append-icon="vpn_key">
    </v-text-field>
  </v-flex>
  <v-spacer/>
</div>
</template>

<script>
export default {
  data: () => ({}),
  props: ["pin"],
  computed: {
    pinInput: {
      get: function() {
        return this.pin;
      },
      set: function(newValue) {
        this.$emit("update:pin", newValue);
      }
    }
  },
  methods: {}
};
</script>

<style>
</style>
